import { CheckPageFormutil } from '../type';

export function handleCheckPageParams(checkPagePrams: CheckPageFormutil) {
    const { files } = checkPagePrams;

    return {
        ...checkPagePrams,
        files: files.map(({ url }) => url).filter(Boolean)
    };
}
